<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GYu1hg/images/cover.png?1685203786186" alt="This image is the cover for the book An Intriguing Proposition (The Defiant Hearts Series, Prequel), The Defiant Hearts Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">An Intriguing Proposition (The Defiant Hearts Series, Prequel), The Defiant Hearts Series
      </h1>
      <p class="bookDescription body article font2">
        <p>Following her father's untimely death, eldest daughter Elise Malloy discovers that the family home is collateral for a mysterious loan. With no record of payments made from her father's accounts, whoever was paying the bank has now stopped, and foreclosure is imminent.<br/>Desperate to keep the news from her grieving, funds-starved family, Elise answers the bank summons and faces Michael Bradley, an old flame who still owns her heart. When Michael extends an unseemly dinner invitation, Elise invents a nameless suitor as an excuse to refuse.<br/>Now, to save face, she must produce him.<br/>Jonathon Amory, Esquire, seems the perfect choice, until her long-desired relationship with Michael unexpectedly catches fire, and Jonathon makes it clear he will stop at nothing to destroy her family and lock her into a loveless marriage.<br/><br/>REVIEWS:<br/>"...a glittering tale of star-crossed lovers, threatened by a web of lies... a great new book in a new series." ~Adrienne deWolfe, Bestselling Author of Scoundrel for Hire<br/><br/>"...a tantalizing glimpse of the author's delicate writing style as she melds romance with humor, conflict, and adventure. An entertaining read." ~Bestselling Author, Marliss Melton<br/><br/>THE DEFIANT HEARTS SERIES, in order <br/>An Intriguing Proposition<br/>An Improper Situation<br/>An Irresistible Temptation<br/>An Inescapable Attraction<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sydney Jane Baily
      </h2>
      
      <p class="authorDescription body article">Sydney Jane Baily completed her first novel at the tender age of 17. Thankfully, that manuscript resides in an undisclosed secure location. After spending years as a book editor, Sydney is thrilled to be crafting her own stories of a bygone era. She resides in New England with her family—human, feline, and canine. www.sydneyjanebaily.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ePublishing Wokrs!
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5ae1669b